module.exports = __webpack_public_path__ + "img/moscow.4003a8f9.png";